




















































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { storePasien } from "@/store/modules/pasien";
import {
  SuketBaseWithRelationship,
  SuketGadarContentInterface
} from "@/types/suket_gawat_darurat";
import { getAge, formatDMYDate } from "@/utility/DateUtils";
import SuketGawatDarurat from "@/services/SuketGawatDarurat";
import StoreSuketGawatDarurat from "@/store/modules/SuketGawatDarurat";
import { storeDokter } from "@/store/modules/dokter";
// import AsesmenMedisIgdStore from "@/store/modules/AsesmenMedisIgdStore";
import AsesmenGadarMedisStore from "@/store/modules/AsesmenAwalGadar/AsesmenGadarMedisStore";
import moment from "moment";

@Component({
  components: {
    CardModalTtd
  }
})
export default class SuketGawatDaruratInputCard extends Vue {
  @Prop() readonly register!: string;
  @Prop() dataSuket!: SuketBaseWithRelationship<SuketGadarContentInterface>;
  @Prop() readonly instantCreate: boolean;

  register_id = this.dataSuket?.register_id || this.register;
  pasien_rm = this.dataSuket?.pasien_rm || this.pasien.rm;
  unit_id = this.dataSuket?.unit_id || this.user.unit_id;
  nama = this.pasien.nama;
  umur =
    this.dataSuket?.pasien.umur ||
    getAge(formatDMYDate(this.pasien.tgl_lahir))
      .toString()
      .concat(" Th");
  pekerjaan = this.pasien.pekerjaan;
  alamat_type = this.dataSuket?.content.alamat_type;
  diagnosis = this.dataSuket?.content.diagnosis || null;
  surat_date = this.dataSuket?.surat_date || moment().format("YYYY-MM-DD");
  signee_user_id = this.dataSuket?.signee_user_id || this.user.id;
  creator_user_id = this.dataSuket?.creator_user_id || this.user.id;

  maxDate = moment().format("YYYY-MM-DD");
  showSuratDatePicker = false;
  validasi = [v => !!v || "*Kolom ini harus diisi"];
  saving = false;

  get pasien() {
    return storePasien.identitasPasien;
  }

  get alamatOptions() {
    const opts = [
      {
        id: "ktp",
        name: this.pasien.alamat,
        category: "Alamat KTP"
      }
    ];

    if (this.pasien.alamat_domisili) {
      opts.push({
        id: "domisili",
        name: this.pasien.alamat_domisili,
        category: "Alamat Domisili"
      });
    }

    return opts;
  }

  get user() {
    return userModule.user;
  }

  get input() {
    return {
      register_id: this.register_id,
      pasien_rm: this.pasien_rm,
      unit_id: this.unit_id,
      content: {
        alamat_type: this.alamat_type,
        diagnosis: this.diagnosis
      },
      surat_date: this.surat_date,
      signee_user_id: this.signee_user_id,
      creator_user_id: this.creator_user_id
    };
  }

  get listDokter() {
    return storeDokter.list;
  }

  get canSign() {
    return this.user.id == this.signee_user_id;
  }

  get asesmenGadarMedis() {
    // return AsesmenMedisIgdStore.asesmen;
    return AsesmenGadarMedisStore.asesmen;
  }

  @Watch("instantCreate")
  changeInstantCreate(val) {
    if (val) {
      this.save();
    }
  }

  mounted() {
    if (!this.diagnosis) {
      this.diagnosis = this.asesmenGadarMedis?.content.diagnosis.kerja;
    }

    if (!this.alamat_type) {
      this.alamat_type = "ktp";
    }
  }

  save() {
    if (!this.saving) {
      this.saving = true;

      const action = this.dataSuket
        ? SuketGawatDarurat.update(this.dataSuket.id, this.input)
        : SuketGawatDarurat.create(this.input);

      action
        .then(() => {
          if (this.canSign) {
            this.$emit("showSignatureModal");
          }

          appModule.NoticeDelay("Berhasil Simpan");

          this.close();

          StoreSuketGawatDarurat.getSuketByRegister(this.register);
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }

  close() {
    this.$emit("close");
  }
}
